import { ORG_CONFIG_PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Shield } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance')({
    staticData: {
        breadcrumb: {
            title: 'Compliance',
            inactive: true,
        },
        permissions: ORG_CONFIG_PERMISSIONS,
        ui: {
            icon: Shield,
        },
    },
    component: ComplianceConfigurationLayout,
});

function ComplianceConfigurationLayout() {
    return <Outlet />;
}
